import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { PageProps } from 'types/page'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import { CreditAuthorizationAgreement } from 'experiences/creditAuthorizationAgreement'

const CreditAuth: NextPage<PageProps> = ({ metaTags }): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<CreditAuthorizationAgreement />
	</StandardLayout>
)

export const getServerSideProps = defaultSSRProps

export default CreditAuth
